/**
 * Whether a list request widens its cancer type to the type's subtree.
 *
 * The flag means nothing without a cancer type, so it is dropped there rather
 * than sent: a list with no filter keeps one cache key whether or not the
 * caller opted in.
 */
export function expandsCancerTypeSubtree({
  cancerTypeId,
  includeDescendants,
}: {
  cancerTypeId?: number;
  includeDescendants?: boolean;
}) {
  return Boolean(includeDescendants) && cancerTypeId !== undefined;
}
